
import { Record } from "../Client/src/fable_modules/fable-library-js.5.0.0/Types.js";
import { union_type, lambda_type, class_type, unit_type, record_type, string_type, array_type, int32_type } from "../Client/src/fable_modules/fable-library-js.5.0.0/Reflection.js";
import { Prompt_$reflection, Observation_$reflection } from "../../NetHack.Api/Domain.fs.js";
import { Note_$reflection } from "../../NetHack.Agent/Note.fs.js";
import { FSharpResult$2 } from "../Client/src/fable_modules/fable-library-js.5.0.0/Result.js";

/**
 * Client-server DTO.
 */
export class SessionState extends Record {
    constructor(Index, Observation, Pending, CurrentNotes, RelevantNotes, NotesToDelete, NotesToAdd, Action, Prediction) {
        super();
        this.Index = (Index | 0);
        this.Observation = Observation;
        this.Pending = Pending;
        this.CurrentNotes = CurrentNotes;
        this.RelevantNotes = RelevantNotes;
        this.NotesToDelete = NotesToDelete;
        this.NotesToAdd = NotesToAdd;
        this.Action = Action;
        this.Prediction = Prediction;
    }
}

export function SessionState_$reflection() {
    return record_type("NetHack.Web.SessionState", [], SessionState, () => [["Index", int32_type], ["Observation", Observation_$reflection()], ["Pending", Prompt_$reflection()], ["CurrentNotes", array_type(Note_$reflection())], ["RelevantNotes", array_type(int32_type)], ["NotesToDelete", array_type(int32_type)], ["NotesToAdd", array_type(Note_$reflection())], ["Action", string_type], ["Prediction", string_type]]);
}

/**
 * Client-server NetHack web API.
 */
export class INetHackApi extends Record {
    constructor(GetStateCount, GetSessionState) {
        super();
        this.GetStateCount = GetStateCount;
        this.GetSessionState = GetSessionState;
    }
}

export function INetHackApi_$reflection() {
    return record_type("NetHack.Web.INetHackApi", [], INetHackApi, () => [["GetStateCount", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [int32_type]))], ["GetSessionState", lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [SessionState_$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", SessionState_$reflection()]], [["ErrorValue", string_type]]])]))]]);
}

